import React from 'react';
import cx from 'classnames';
import styles from './styles.module.scss';
import {Icon, PriorityIcon, Text} from '@priority-software/priority-style-react';

type Props = {
    text: string;
    type: 'success' | 'error';
    onClose?: () => void;
};

export const EntityNotification = (props: Props) => {
    const {text, type, onClose} = props;
    return (
        <Text
            tag="div"
            skin="paragraph-1"
            componentClasses={cx(styles.component, {
                [styles.success]: type === 'success'
            })}
        >
            <Icon componentClasses={styles.icon} icon={PriorityIcon.roundCheck} />
            {text}
            <Icon icon={PriorityIcon.closeSmall} iconColor="secondary-500" onClick={onClose} />
        </Text>
    );
};
